// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PostSearchFiltersSidebar from 'components/PostSearchFiltersSidebar';
import type { Subsite } from 'api/website';
import type { Dispatch } from '../redux/main';
import {
  setSearchFilter,
  selectSearchFilterOption,
  deselectSearchFilterOption,
  selectAllSearchFilterOptions
} from '../redux/main/actions/postSearch';

const mapStateToProps = ({
  postSearch: { filters, searchFacets, facetsThatArentLoaded }
}) => ({
  filters,
  searchFacets,
  facetsThatArentLoaded
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators(
    {
      setSearchFilter,
      selectAllSearchFilterOptions,
      selectSearchFilterOption,
      deselectSearchFilterOption
    },
    dispatch
  )
});

type OwnProps = {|
  subsite: Subsite,
  parentSubsite: ?Subsite
|};

type Props = {
  ...OwnProps,
  filters: SearchFilters,
  searchFacets: Object,
  facetsThatArentLoaded: Array<string>,
  setSearchFilter: Function,
  selectSearchFilterOption: Function,
  deselectSearchFilterOption: Function,
  selectAllSearchFilterOptions: Function
};

const PostSearchFiltersSidebarContainer = (props: Props) => (
  <PostSearchFiltersSidebar {...props} />
);

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(PostSearchFiltersSidebarContainer);
